import SideBase from '@x3/js/side/0_mixin/side-base.vue';
import SideFoot from '@x3/vue/comp/x3-foot-btn.vue';
import SideIconSelect from '@x3/js/side/0_mixin/side-icon-select.vue';
import SearchFilter from '@x3/vue/comp/search-filter.vue';
import SearchFilterNew from '@x3/vue/comp/search-filter-new.vue';

const sideMixin = {
  provide() {
    return {
      close: this.close,
      confirm: this.confirm,
    };
  },
  components: {
    SideBase,
    SideFoot,
    SideIconSelect,
    SearchFilter,
    SearchFilterNew,
  },
  methods: {
    async close() {
      this.$router.back();
      await app.tool.timeout(100);
    },
    async confirm(result) {
      // 当result == 'occlude'时；需要阻塞住，不用关闭弹窗，所以什么事都不用干。
      if (result !== 'occlude') {
        await this.close();
        const resolve = this.$vxRoute.meta._resolve;
        if (resolve && result !== false) {
          resolve(result);
        }
      }
    },
  },
  created() {
    console.log('弹窗mixin-base, 提供this.options, this.close, this.confirm');
    this.options = this.$vxRoute.meta.options || {};
  },
};

export default sideMixin;
